// extracted by mini-css-extract-plugin
module.exports = {"countdown":"_5Vso-n","withDecor":"_1Dycyt","digits":"_2jEuBp","title":"_25hxvD","box":"_2s95FO"};